import addColourToHeadings from './addColourToHeadings';
import addDirectionToHeadings from './addDirectionToHeadings';
import addDisplayTableHeading from './addDisplayTableHeading';
import addHeaderPadding from './addHeaderPadding';
import addUnitLabelsToHeadings from './addUnitLabelsToHeadings';
import addVectorNormalizationToHeadings from './addVectorNormalizationToHeadings';
import migrateToDirectionalVisualization from './migrateToDirectionalVisualization';
import addDirectionalVisualizationToHeading from './addDirectionalVisualizationToHeading';

export default [
    addColourToHeadings,
    migrateToDirectionalVisualization,
    addDisplayTableHeading,
    addHeaderPadding,
    addVectorNormalizationToHeadings,
    addUnitLabelsToHeadings,
    addDirectionToHeadings,
    addDirectionalVisualizationToHeading,
];
